<div class="row pt-4">
    <div class="col-md-12">
        <div class="card p-3">
            <div class="col-sm">
                <div class="d-flex flex-row align-items-center">
                    <h5 class="mb-0 mr-auto">Configuração do Envio de E-mail</h5>
                </div>                     
            </div>
            <hr>
            <form role="form" [formGroup]="formParamEmail" (ngSubmit)="submit()">
                <!-- <div class="d-flex flex-row align-items-center"> -->
                <div class="row">
                    <div class="form-group col-md-6">
                        <strong>Assunto *</strong>
                        <input id="assunto" type="text" class="form-control" formControlName="assunto">
                        <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                        *ngIf="!formParamEmail.get('assunto').valid && ( formParamEmail.get('assunto').touched || submit )">
                            <small>Campo assunto é obrigatório!</small>
                        </span>
                    </div>
                    <div class="form-group col-md-6">
                        <strong>Título *</strong>
                        <input id="titulo" type="text" class="form-control" formControlName="titulo">
                        <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                        *ngIf="!formParamEmail.get('titulo').valid && ( formParamEmail.get('titulo').touched || submit )">
                            <small>Campo título é obrigatório!</small>
                        </span>
                    </div>
                </div>
                <br>
                <div class="row">                    
                    <div class="col-sm">
                        <strong>Mensagem *</strong>
                        <angular-editor id="mensagem" formControlName="mensagem" [config]="editorConfig"></angular-editor>
                        <span class="alert alert-danger m-2 p-1"
                        *ngIf="!formParamEmail.get('mensagem').valid && ( formParamEmail.get('mensagem').touched || submit )">
                            <small>Campo mensagem é obrigatório!</small>
                        </span> 
                    </div>
                </div>
                <br>
                    <button type="submit" class="btn btn-success btn-custom" [disabled]="btOff">Salvar</button>
            </form>
        </div>
    </div>
</div>